import React from 'react';
import { injectIntl } from 'react-intl';
import { Modal } from 'antd';
import BRButton from 'components/BRButton/BRButton';

import './ConfirmationModal.less';

const ConfirmationModal = ({
  intl,
  close,
  modalAction = () => {},
  title,
  subtitle,
  content,
  confirmButtonLabel,
  cancelButtonLabel,
  confirmButtonProps = {},
  cancelAction = false,
  confirmButtonType,
  ...props
}) => {
  const confirmAction = () => {
    close();
    modalAction();
  };

  const onCancel = () => {
    close();
    if (cancelAction) {
      cancelAction();
    }
  };

  return (
    <Modal
      title={
        <div className="br-confirmation-modal__header">
          <span className="br-confirmation-modal__header-title">{title}</span>
          <span className="br-confirmation-modal__header-subtitle">
            {subtitle}
          </span>
        </div>
      }
      onCancel={onCancel}
      width={null}
      wrapClassName="br-confirmation-modal font-family__default"
      footer={
        <>
          <BRButton
            className="button"
            type="basic"
            label={
              cancelButtonLabel ||
              intl.formatMessage({
                id: 'common.cancel'
              })
            }
            onClick={onCancel}
          />

          <BRButton
            className="button"
            type={confirmButtonType || 'destructive-primary'}
            label={
              confirmButtonLabel ||
              intl.formatMessage({
                id: 'common.delete'
              })
            }
            onClick={confirmAction}
            {...confirmButtonProps}
          />
        </>
      }
      maskClosable={false}
      {...props}
    >
      <span className="body">{content}</span>
    </Modal>
  );
};

export default injectIntl(ConfirmationModal);
